import {RemoteGetExamsTypesLocation} from 'data/usecases';
import {GetExamsTypesLocation} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetExamsTypesLocation = (): GetExamsTypesLocation =>
	new RemoteGetExamsTypesLocation(
		makeBFFApiUrl(BookingFlowEndPoints.examsTypesLocation),
		makeAuthorizeHttpClientDecorator(),
	);
